// extracted by mini-css-extract-plugin
export var menuRight = "menu-right-module--menu-right--tETs1";
export var link = "menu-right-module--link--q6Vga";
export var icon = "menu-right-module--icon--Ldz4w";